import React, { useState } from 'react';
import { productService } from '../../services/financeService';
import './Financial.css';

// Sorted-out material is graded by quality. These are the names this business already uses; the
// "Add the standard grades" button creates whichever of them do not exist yet.
export const STANDARD_WASTE_GRADES = ['Chaant', 'Jamboo', 'Goli', 'Safi'];

// A waste grade is stored as a catalog item of category SELLABLE_WASTE, so it has stock, can go on a
// gate pass and can be invoiced like anything else - but the screens only ever call it a "waste grade".
export const isWasteGrade = (p) => p && p.category === 'SELLABLE_WASTE';

export const createWasteGrade = async (name) => {
  const clean = name.trim();
  let code = null;
  try { code = await productService.suggestCode(clean); } catch { /* fall back below */ }
  const res = await productService.create({
    productCode: code || `WG-${clean.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 12)}`,
    name: clean,
    category: 'SELLABLE_WASTE',
    unit: 'KG',
  });
  if (!res.success) throw new Error(res.message || 'Could not add the waste grade');
  return res.data;
};

/** Small pop-up to add one waste grade (e.g. "Goli"). onCreated gets the new catalog record. */
const WasteGradeModal = ({ existing = [], onCreated, onClose }) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!name.trim()) { setErr('Enter the grade name'); return; }
    if (existing.some(g => g.name.toLowerCase() === name.trim().toLowerCase())) {
      setErr(`"${name.trim()}" already exists`); return;
    }
    setSaving(true); setErr(null);
    try { onCreated(await createWasteGrade(name)); }
    catch (e2) { setErr(e2.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 'calc(var(--z-overlay) + 5)' }} onClick={() => !saving && onClose()}>
      <div className="modal-content" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>New waste grade</h3>
          <button type="button" className="modal-close" onClick={() => !saving && onClose()}>✕</button>
        </div>
        <form onSubmit={submit}>
          {err && <div style={{ background: 'var(--color-error-light)', color: 'var(--color-error)', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: 13 }}>{err}</div>}
          <div className="form-group">
            <label className="form-label">Grade name *</label>
            <input className="form-control" autoFocus placeholder="e.g. Goli" value={name} onChange={e => setName(e.target.value)} />
            <span style={{ fontSize: 12, color: 'var(--color-text-secondary)', marginTop: 4, display: 'block' }}>
              Sorted-out material of this grade is tracked in kg and sold with a Sellable Waste gate pass + invoice.
            </span>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-secondary" disabled={saving} onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Adding…' : 'Add grade'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WasteGradeModal;
